module.exports = __webpack_public_path__ + "static/fb-image-3d0a68398576bd74b927b8836280a444.jpg";